import { Fragment, useMemo } from "react";
import { getExtraInfo } from "src/pages/OfferPage/QuoteHeader/CompanyInfo/companyInfoUtils";
import 'src/styles/quote.css'
import { IMAGE_HOST } from "src/utils/constants";
import { QuoteData } from "src/model/api/quote-data.model";
import { Box, Stack } from '@mui/material';

export const CompanyInfo = (props: { quoteData: QuoteData; }) => {
  const { quoteData } = props;

  const imgHost = `${IMAGE_HOST}images/avatars/`;

  const extras = useMemo(
    () => getExtraInfo(quoteData),
    [quoteData]
  );

  return (
    <>
      <Stack className="quote-companyinfo-container" direction="row" gap="10px" sx={{marginTop: '15px', padding: '5px'}}>
        <Box>
          {extras.slice(0, 4).map((elem) => (
              <div
                  className="quote-companyinfo-row"
                  key={elem.key}
                  style={{
                    fontSize: elem.bold ? "24px" : "inherit",
                    fontWeight: elem.bold ? 600 : "inherit",
                    whiteSpace: elem.bold ? "nowrap" : "inherit"
                  }}
              >
                {elem.content}
              </div>
          ))}
        </Box>
        <Box flexGrow="1" sx={{ marginTop: "40px" }}>
          {extras.slice(4).map((elem) => (
              <div
                  className="quote-companyinfo-row"
                  key={elem.key}
                  style={{
                    fontSize: elem.bold ? "24px" : "inherit",
                    fontWeight: elem.bold ? 600 : "inherit",
                    whiteSpace: elem.bold ? "nowrap" : "inherit"
                  }}
              >
                {elem.content}
              </div>
          ))}
        </Box>
        <Box>
          {quoteData.user_company_link ? (
              <img
                  className="quote-coverpage-image"
                  src={`${imgHost}${quoteData.user_company_link}`}
                  alt="Quote Cover Image"
              />
          ) : null}
        </Box>
      </Stack>
    </>
  );
};
